import $request from './request'
import { publicUrl, dataUrl } from './config'

// notice/head获取头部通知
export function noticeHead(data) {
  return $request.get(publicUrl + '/notice/head', data)
}

// 获取所有租户
export function queryTenantName(data) {
  return $request.post(publicUrl + '/tenant/queryTenantName', data)
}

// 获取租户key配置
export function getTenantConfig(data) {
  return $request.post(publicUrl + '/tenantConfig/getTenantConfig', data)
}

// 获取租户配置明细
export function queryConfigDetail(data) {
  return $request.get(publicUrl + '/tenantConfig/queryDetail/' + data.tenantCode, data)
}

// 获取租户配置明细
export function saveConfig(data) {
  return $request.post(publicUrl + '/tenantConfig/saveConfig', data)
}

// 租户分页
export function getTenantPage(data) {
  return $request.post(publicUrl + '/tenant/page', data)
}

// 付费记录
export function queryPayLog(data) {
  return $request.get(publicUrl + '/tenant/queryPayLog/' + data.id, data)
}

// 新增租户
export function createTenant(data) {
  return $request.post(publicUrl + '/tenant/createTenant', data)
}

// 租户详情
export function getTenantDetail(data) {
  return $request.get(publicUrl + '/tenant/get/' + data.id, data)
}

// 关闭租户
export function closeTenant(data) {
  return $request.get(publicUrl + '/tenant/close/' + data.id, data)
}

// 租户续费
export function renewTenant(data) {
  return $request.post(publicUrl + '/tenant/renew', data)
}

// 租户重新开通
export function againOpenTenant(data) {
  return $request.post(publicUrl + '/tenant/againOpen', data)
}

// 获取当前租户
export function getCurrentTenant(data) {
  return $request.get(publicUrl + '/tenant/getCurrentTenant', data)
}

// 查询版本
export function getVersionList(data) {
  return $request.post(publicUrl + '/version/page', data)
}

// 新增版本
export function createVersion(data) {
  return $request.post(publicUrl + '/version/create', data)
}

// 获取权限树
export function treeOfAdmin(data) {
  return $request.get(publicUrl + '/role/treeOfAdmin', data)
}

// 版本详情
export function getVersionDetail(data) {
  return $request.get(publicUrl + '/version/detail/' + data.id, data)
}

// 编辑版本
export function editVersion(data) {
  return $request.post(publicUrl + '/version/edit', data)
}

// 编辑版本功能
export function funcAgain(data) {
  return $request.post(publicUrl + '/version/funcAgain', data)
}

// 启用停用版本
export function enableOrDisableVersion(data) {
  return $request.get(publicUrl + '/version/enableOrDisable/' + data.id, data)
}

// 获取企业最近付费记录
export function getTenantPayLastLog(data) {
  return $request.post(publicUrl + '/version/getTenantPayLastLog', data)
}

// 更新日志列表
export function updateLogList(data) {
  return $request.post(publicUrl + '/updateLog/page', data)
}

// 创建更新日志
export function createUpdateLog(data) {
  return $request.post(publicUrl + '/updateLog/create', data)
}

// 更新日志详情
export function getUpdateLogDetail(data) {
  return $request.get(publicUrl + '/updateLog/get/' + data.id, data)
}

// 删除更新日志
export function deleteUpdateLog(data) {
  return $request.get(publicUrl + '/updateLog/delete/' + data.id, data)
}

// 租户更新日志列表
export function queryUpdateLogUserPage(data) {
  return $request.post(publicUrl + '/notice/queryUpdateLogUserPage', data)
}

// 获取租户未读更新日志条数
export function getUpdateLogNumOfNotRead(data) {
  return $request.get(publicUrl + '/notice/getUpdateLogNumOfNotRead', data)
}

// 获取用户更新日志明细
export function updateLogRead(data) {
  return $request.get(publicUrl + '/notice/updateLogRead/' + data.id, data)
}

// 帮助中心列表
export function helpList(data) {
  return $request.post(publicUrl + '/help/page', data)
}

// 创建帮助中心
export function createHelp(data) {
  return $request.post(publicUrl + '/help/create', data)
}

// 编辑帮助中心
export function editHelp(data) {
  return $request.post(publicUrl + '/help/edit', data)
}

// 帮助中心详情
export function getHelpDetail(data) {
  return $request.get(publicUrl + '/help/get/' + data.id, data)
}

// 帮助中心删除
export function deleteHelp(data) {
  return $request.get(publicUrl + '/help/delete/' + data.id, data)
}

// 帮助中心置顶
export function topHelp(data) {
  return $request.get(publicUrl + '/help/top/' + data.id, data)
}

// 获取所有帮助信息列表
export function queryAllHelpList(data) {
  return $request.post(publicUrl + '/help/queryAllHelpList', data)
}

// 药材标准列表
export function getMedicineStandardList(data) {
  return $request.post(dataUrl + '/medicineStandard/page', data)
}

// 新增药材标准
export function createMedicineStandard(data) {
  return $request.post(dataUrl + '/medicineStandard/create', data)
}

// 编辑药材标准
export function editMedicineStandard(data) {
  return $request.post(dataUrl + '/medicineStandard/edit', data)
}

// 删除药材标准
export function deleteMedicineStandard(data) {
  return $request.get(dataUrl + '/medicineStandard/delete/' + data.id, data)
}

// 饮片标准列表
export function getPiecesStandardList(data) {
  return $request.post(dataUrl + '/piecesStandard/page', data)
}

// 新增饮片标准
export function createPiecesStandard(data) {
  return $request.post(dataUrl + '/piecesStandard/create', data)
}

// 编辑饮片标准
export function editPiecesStandard(data) {
  return $request.post(dataUrl + '/piecesStandard/edit', data)
}

// 删除饮片标准
export function deletePiecesStandard(data) {
  return $request.get(dataUrl + '/piecesStandard/delete/' + data.id, data)
}

// 后台管理--饮片执行标准列表
export function getExecuteStandardList(data) {
  return $request.post(dataUrl + '/executeStandard/pageByTenant', data)
}

// 新增饮片执行标准
export function createExecuteStandard(data) {
  return $request.post(dataUrl + '/executeStandard/add', data)
}

// 编辑饮片执行标准
export function editExecuteStandard(data) {
  return $request.post(dataUrl + '/executeStandard/update', data)
}

// 删除饮片执行标准
export function deleteExecuteStandard(data) {
  return $request.get(dataUrl + '/executeStandard/delete/' + data.id, data)
}
